import styled from 'styled-components';
export const Container = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: var(--space-100);
  padding: var(--space-200) var(--space-300);
  min-width: 226px;
`;
export const Title = styled.div `
  color: var(--text-secondary);
  /* body/xs/regular */
  font-family: var(--font-family-body);
  font-size: var(--font-size-200);
  font-style: normal;
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-200); /* 133.333% */
  letter-spacing: var(--font-letter-spacing-looser);
  text-align: left;
`;
export const Content = styled.div `
  display: flex;
  gap: var(--space-400);
  justify-content: space-between;
`;
export const Column = styled.div `
  display: flex;
  flex-direction: column;
  gap: var(--space-200);
`;
export const Item = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-300);
  width: 100%;
`;
export const Label = styled.div `
  color: var(--text-primary);
  /* body/md/regular */
  font-family: var(--font-family-body);
  font-size: var(--font-size-400);
  font-style: normal;
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-400); /* 150% */
  letter-spacing: var(--font-letter-spacing-normal);
`;
export const Value = styled.div `
  color: var(--text-primary);
  /* body/md/regular */
  font-family: var(--font-family-body);
  font-size: var(--font-size-400);
  font-style: normal;
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-400); /* 150% */
  letter-spacing: var(--font-letter-spacing-normal);
  text-align: right;
  width: 100%;
`;
